<template>
  <div>
    <!-- **************** TOP NAVBAR ****************************** -->
    <nav class="navbar navbar-expand-md pt-1">
      <div class="container-fluid">
        <!-- Left side of Navbar -->
        <router-link tag="div" to="/" exact>
          <a class=" ml-5 ">
            <img class="big-icon logo-icon" :src="require('@/assets/icons/logo.svg')" alt="Logo icon"/> 
          </a>
        </router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarToggler" aria-controls="navbarToggler" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <!-- Right side of Navbar -->
        <div   class="collapse navbar-collapse" id="navbarToggler">
          <ul class="nav navbar-nav navbar-right ml-auto ">
            <router-link class="nav-item" tag="li" to="/" exact>
              <a class="nav-link">Home</a>
            </router-link>
            <li class="nav-item">
              <a href="http://80.73.144.60/CTN_Geoportal/map/"  target="_blank" class="nav-link">INR-MED</a>
            </li>
            <router-link class="nav-item" tag="li" to="#" exact>
              <a class="nav-link">Risk of impact on biodiversity</a>
            </router-link>
            <router-link class="nav-item" tag="li" to="#" exact>
              <a class="nav-link">Upload data</a>
            </router-link>
            <router-link class="nav-item" tag="li" to="#" exact>
              <a class="nav-link">Download data</a>
            </router-link>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "quietmed2Header",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .navbar {
    box-shadow: rgba(50, 50, 50, 0.5) 0px 3px 5px 0px;
    z-index: 10000;
    background-color: white;
  }
  .logo-icon {
    margin-bottom: 8px;
    margin-top: 8px;
  }
  .big-icon {
    width: 350px;
  }
  a{
    color: #00A7E3;
    font-weight: 600;
  }
</style>
